// import firebase from 'firebase/app';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import { QueryCancelRequestedParams } from './params/query-cancel-requested-params';
import { LogParams } from './params/log-params';
import { Analytics, AnalyticsCallOptions, logEvent } from 'firebase/analytics';
import { NavigateParams } from './params/navigate-params';
import { QueryRunRequestedParams } from './params/query-run-requested-params';
import { IQueryContext } from '../query-context/models/IQueryContext';

export class Events {
    enabled = true;

    constructor(private analytics: Analytics) {}

    loggedIn(): void {
        this.logEvent('LoggedIn');
    }

    log(params: LogParams): void {
        this.logEvent('Log', params);
    }

    navigate(params: NavigateParams) {
        this.logEvent('Navigate', params);
    }

    mockupTest() {
        this.logEvent('MockupTest');
    }

    contextApplied(context: IQueryContext) {
        this.logEvent('ContextApplied', context);
    }

    private logEvent(
        eventName: string,
        eventParams?: { [key: string]: any } | undefined,
        options?: AnalyticsCallOptions | undefined
    ) {
        if (!this.enabled) {
            return;
        }

        logEvent(this.analytics, eventName, eventParams, options);
    }
}
